import { LinkIcon } from '@phosphor-icons/react';
import { Components } from 'react-markdown';
import React from 'react';
export const markdownComponents: Components = {
  h1: ({
    children
  }) => <h1 className="w-full text-white font-semibold text-lg sm:text-2xl border-b-[2px] border-solid border-blue-300 m-0 mb-1 p-0 pb-1">
      {children}
    </h1>,
  h2: ({
    children
  }) => <h2 className="text-blue-400 font-semibold text-md sm:text-xl p-0 m-0 mb-1">
      {children}
    </h2>,
  h3: ({
    children
  }) => <h3 className="text-blue-300 font-medium text-base sm:text-lg italic p-0 m-0 mb-1">
      {children}
    </h3>,
  ul: ({
    children
  }) => <ul className='list-disc list-outside p-0 m-0 ml-8'>{children}</ul>,
  ol: ({
    children
  }) => <ol className='list-decimal list-outside p-0 m-0 ml-8'>{children}</ol>,
  li: ({
    children
  }) => <li className='text-white font-light text-base leading-snug m-0 pb-2'>{children}</li>,
  p: ({
    children,
    ...props
  }) => {
    const isInBlockquote = props.className?.includes('blockquote');
    if (isInBlockquote) {
      return <p className="text-white font-light text-[18px] leading-snug m-0 my-1">{children}</p>;
    }
    return <p className="text-white font-light text-base leading-snug m-0 pb-2">{children}</p>;
  },
  a: ({
    node,
    ...props
  }) => {
    const href = node?.properties?.href as string;
    return <a href={href} target="_blank" rel="noopener noreferrer" className="text-base text-blue-300 hover:text-blue-500 no-underline flex flex-row items-center gap-1">
        {props.children}
        <LinkIcon size={14} weight="light" className='mt-[-12px]' />
      </a>;
  },
  sup: ({
    children
  }) => <sup className="text-[19px] leading-[14px] bg-[#2C3A4A] text-white rounded-full ml-0.5 min-w-[14px] min-h-[14px] inline-block align-middle text-center whitespace-nowrap">
      {children}
    </sup>,
  table: ({
    children
  }) => <table className="w-full border-collapse border border-gray-700">{children}</table>,
  th: ({
    children
  }) => <th className="border border-gray-700 border-solid bg-gray-800 p-2 font-semibold tracking-wider">
      {children}
    </th>,
  tr: ({
    children
  }) => <tr className="border border-gray-700 border-solid even:bg-gray-600 odd:bg-gray-900">
      {children}
    </tr>,
  td: ({
    children
  }) => <td className="border border-gray-700 border-solid p-2">{children}</td>,
  blockquote: ({
    children
  }) => <blockquote className="text-white font-light text-[16px] leading-snug m-0 my-1 py-1 pl-4 border-l-[3px] border-solid border-blue-300 italic">
      {children}
    </blockquote>,
  hr: () => <hr className="border-blue-300 border-solid border-b-[2px] w-full my-2" />
};